import { useConditionsContext } from "./ConditionsDialog";
import ConditionsList from "./ConditionsList";
import type { ApplicationCondition } from "src/types/conditions";

interface ExistingConditionUploadProps {
  conditions: ApplicationCondition[];
  isLoading: boolean;
  stepNumber: number;
}

/**
 * Component for uploading files to pre-existing conditions from DigiFi.
 * Only displayed when Porchpass is the selected lender.
 */
export default function ExistingConditionUpload({
  conditions,
  isLoading,
  stepNumber,
}: ExistingConditionUploadProps) {
  const { conditionFiles, setConditionFile } = useConditionsContext();

  if (isLoading) {
    return (
      <div>
        <div className="flex flex-row gap-2 text-[14px] font-semibold mb-2">
          <span className="text-[#1453F5] bg-[#E1E8FF] rounded-full w-6 h-6 flex items-center justify-center">
            {stepNumber}
          </span>
          <p className="text-[#697083] flex items-center justify-center">
            UPLOAD DOCUMENTS (OPTIONAL)
          </p>
        </div>
        <p className="text-sm font-normal text-[#4A5466] mb-4">
          Loading conditions...
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex flex-row gap-2 text-[14px] font-semibold mb-2">
        <span className="text-[#1453F5] bg-[#E1E8FF] rounded-full w-6 h-6 flex items-center justify-center">
          {stepNumber}
        </span>
        <p className="text-[#697083] flex items-center justify-center">
          UPLOAD DOCUMENTS (OPTIONAL)
        </p>
      </div>
      <p className="text-sm font-normal text-[#4A5466] mb-4">
        Upload documents individually to each pending condition.
      </p>
      <ConditionsList
        conditions={conditions}
        onFileSelect={setConditionFile}
        uploadedFiles={conditionFiles}
      />
    </div>
  );
}
